export const fmtMoney = (n) => {
  const num = Number(n || 0);
  const sign = num < 0 ? "-" : "";
  return `${sign}₹${Math.abs(num).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;
};

// Static class literals so Tailwind keeps them.
export const SHIFT_PALETTE = [
  "bg-amber-50 text-amber-700 border-amber-200",
  "bg-sky-50 text-sky-700 border-sky-200",
  "bg-indigo-50 text-indigo-700 border-indigo-200",
  "bg-emerald-50 text-emerald-700 border-emerald-200",
  "bg-violet-50 text-violet-700 border-violet-200",
  "bg-teal-50 text-teal-700 border-teal-200",
  "bg-orange-50 text-orange-700 border-orange-200",
  "bg-fuchsia-50 text-fuchsia-700 border-fuchsia-200",
];
export const ABSENT_STYLE = "bg-rose-100 text-rose-800 border-rose-300";

export const shiftStyle = (index) => SHIFT_PALETTE[index % SHIFT_PALETTE.length];

// "07:00" -> "7:00 AM"
export const fmtTime12 = (hhmm) => {
  if (!hhmm) return "";
  const [h, m] = hhmm.split(":").map(Number);
  const period = h < 12 ? "AM" : "PM";
  const h12 = h % 12 === 0 ? 12 : h % 12;
  return `${h12}:${String(m).padStart(2, "0")} ${period}`;
};

// Build helpers from a shifts array (ordered)
export const buildShiftMaps = (shifts) => {
  const label = {}; // id -> "S1"
  const name = {}; // id -> full name
  const style = {}; // id -> badge classes
  const index = {}; // id -> i
  shifts.forEach((s, i) => {
    label[s.id] = `S${i + 1}`;
    name[s.id] = s.name;
    style[s.id] = shiftStyle(i);
    index[s.id] = i;
  });
  return { label, name, style, index };
};

export const balanceClass = (b) =>
  Number(b) < 0
    ? "text-rose-700 font-semibold"
    : Number(b) > 0
    ? "text-emerald-700 font-semibold"
    : "text-slate-500";

export const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

export const todayStr = () => new Date().toISOString().slice(0, 10);
export const thisMonth = () => new Date().toISOString().slice(0, 7);

export const shiftMonth = (month, delta) => {
  let [y, m] = month.split("-").map(Number);
  m += delta;
  if (m < 1) { m = 12; y -= 1; }
  if (m > 12) { m = 1; y += 1; }
  return `${y}-${String(m).padStart(2, "0")}`;
};

// ---- Indian-numbering-system amount-in-words (lakh/crore) ----
const ONES = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
  "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
const TENS = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

const twoDigitWords = (n) => {
  if (n < 20) return ONES[n];
  const t = Math.floor(n / 10), r = n % 10;
  return TENS[t] + (r ? ` ${ONES[r]}` : "");
};
const threeDigitWords = (n) => {
  let str = "";
  if (n >= 100) {
    str += `${ONES[Math.floor(n / 100)]} Hundred`;
    n %= 100;
    if (n) str += " ";
  }
  if (n) str += twoDigitWords(n);
  return str;
};

// e.g. 1234567 -> "Twelve Lakh Thirty Four Thousand Five Hundred Sixty Seven"
export const numberToWordsIndian = (num) => {
  num = Math.round(Math.abs(Number(num) || 0));
  if (num === 0) return "Zero";
  const crore = Math.floor(num / 10000000); num %= 10000000;
  const lakh = Math.floor(num / 100000); num %= 100000;
  const thousand = Math.floor(num / 1000); num %= 1000;
  const rest = num;
  const parts = [];
  if (crore) parts.push(`${threeDigitWords(crore)} Crore`);
  if (lakh) parts.push(`${threeDigitWords(lakh)} Lakh`);
  if (thousand) parts.push(`${threeDigitWords(thousand)} Thousand`);
  if (rest) parts.push(threeDigitWords(rest));
  return parts.join(" ");
};

// e.g. 12500.5 -> "Twelve Thousand Five Hundred Rupees and Fifty Paise Only"
export const amountInWords = (n) => {
  const num = Number(n);
  if (!num || isNaN(num) || num <= 0) return "";
  const sign = num < 0 ? "Minus " : "";
  const abs = Math.abs(num);
  const rupees = Math.floor(abs);
  const paise = Math.round((abs - rupees) * 100);
  let words = `${sign}${numberToWordsIndian(rupees)} Rupee${rupees === 1 ? "" : "s"}`;
  if (paise > 0) words += ` and ${numberToWordsIndian(paise)} Paise`;
  return `${words} Only`;
};
